var H;
((s) => {
  ((o) => {
    o[o.Unknown = 0] = "Unknown", o[o.Forms = 1] = "Forms", o[o.HomeGroup = 2] = "HomeGroup", o[o.House = 3] = "House", o[o.Year = 4] = "Year", o[o.DmGroup = 5] = "DmGroup", o[o.SubSchool = 6] = "SubSchool";
  })(s.StaffGroupTypeEnum || (s.StaffGroupTypeEnum = {}));
})(H || (H = {}));
export {
  H as groups
};
//# sourceMappingURL=index.js.map
